import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBatchDelete = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 2831",
		children: [/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse 29",
			cx: 12.5,
			cy: 12.5,
			r: 12.5,
			fill: "#F73B3B",
			fillOpacity: .15
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group 127",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M9.16602 9.16797L12.4131 12.3909L9.16602 15.6078",
				stroke: "#F73B3B",
				strokeOpacity: .8,
				strokeWidth: 1.5,
				strokeMiterlimit: 10
			}), /* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M15.9551 9.16797L12.708 12.3909L15.9551 15.6078",
				stroke: "#F73B3B",
				strokeOpacity: .8,
				strokeWidth: 1.5,
				strokeMiterlimit: 10
			})]
		})]
	})
});
export default SvgBatchDelete;
